// extracted by mini-css-extract-plugin
export var buttons = "_41-0";
export var buttonsActive = "_41-h";
export var cancelConfirm = "_41-1";
export var closeButton = "_41-2";
export var column = "_41-3";
export var container = "_41-4";
export var detailHeader = "_41-6";
export var detailTitle = "_41-7";
export var detailsContent = "_41-5";
export var header = "_41-8";
export var headerWithClose = "_41-9";
export var icon = "_41-a";
export var infoIcon = "_41-c";
export var informationContainer = "_41-b";
export var sideDrawer = "_41-d";
export var sideDrawerOpen = "_41-e";
export var stickyFooter = "_41-f";
export var typeOption = "_41-g";